import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("attribute-filter-panel", {
        attrs: {
          "filter-rules": _vm.selectedAttributeFilters,
          "enable-wholesale-hierarchy-filters": "",
          "title-localisation": "attributes.filters.filterByAttributes",
          "filter-count-localisation": "attributes.filters.numApplied",
        },
        on: { attributeFilterChange: _vm.setWholesaleFilters },
      }),
      _vm._v(" "),
      _c(
        VTabs,
        {
          staticClass: "pricing-tabs",
          attrs: {
            height: "4rem",
            "background-color": "transparent",
            color: "white",
            "active-class": "pricing-tabs__tab--active",
            "hide-slider": "",
          },
        },
        [
          _c(
            VTab,
            { staticClass: "pricing-tabs__tab pricing-tabs__tab--first" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("wholesale.tabs.marginSplits")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(VTab, { staticClass: "pricing-tabs__tab" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("wholesale.tabs.wholesaleMargins")) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(VTab, { staticClass: "pricing-tabs__tab" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("wholesale.tabs.wholesaleHistoryChart")) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _vm.canRunWholesaleEngine
            ? _c(
                "div",
                { staticClass: "d-flex align-center" },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "ml-4 btn-run-simulation",
                      attrs: {
                        color: "primary",
                        small: "",
                        depressed: "",
                        disabled: _vm.wholesaleEngineLoading,
                        loading: _vm.wholesaleEngineLoading,
                      },
                      on: { click: _vm.runWholesaleEngine },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("wholesale.runSimulation")) +
                          "\n        "
                      ),
                      _c("cog-play-icon"),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(VTabItem, [_c("margin-splits")], 1),
          _vm._v(" "),
          _c(VTabItem, [_c("wholesale-margins")], 1),
          _vm._v(" "),
          _c(VTabItem, [_c("wholesale-history-chart")], 1),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }